import { render, staticRenderFns } from "./frota-circulante.vue?vue&type=template&id=3ab66eca&scoped=true&"
import script from "./frota-circulante.vue?vue&type=script&lang=js&"
export * from "./frota-circulante.vue?vue&type=script&lang=js&"
import style0 from "./frota-circulante.vue?vue&type=style&index=0&id=3ab66eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab66eca",
  null
  
)

export default component.exports